module.exports = __webpack_public_path__ + "static/media/eye_green.b36c3327.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/eye_green.svg
// module id = 354
// module chunks = 0